import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import TopBarProgress from "react-topbar-progress-indicator";
import { createSearchParams, useLocation } from "react-router-dom";
import moment from "moment";
import {
  deleteMainCategory,
  getMainCategories,
} from "../../../actions/mainCategory";

import CustomeTableBtn from "../../../components/custome-table-button/CustomeTableBtn";
import { Pagination } from "@mui/material";
import DashboardPagesLayout from "../customerServiceDashboard/components/DashboardPagesLayout";
import DeleteConfirmationDialog, {
  confirmButtonType,
} from "../../../components/dialog-boxes/delete-confirmation-dialog";

const MainCategories = () => {
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Local State
  const [loading, setloading] = useState(true);
  const [Data, setData] = useState([]);
  const [deleteConfirm, setdeleteConfirm] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
  });

  // Api calls for get Order
  const getCategories = useCallback(async () => {
    const res = await dispatch(getMainCategories());
    setData(res?.mainCategories);
    setpagination({
      ...res?.pagination,
    });
    setloading(false);
  }, [dispatch]);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const page = parseInt(urlParams.get("page")) || 1;
    if (page !== pagination.currentPage) {
      setpagination(prev => ({ ...prev, currentPage: page }));
    }

    var timer = setTimeout(() => {
      getCategories();
    }, 1000);

    return () => {
      clearTimeout(timer);
    };
  }, [getCategories, location.search]);


  // handle page change
  const handleChange = (e, value) => {
    const options = {
      pathname: location.pathname,
      search: `?${createSearchParams({ page: value })}`,
    };
    navigate(options, { replace: true });
    setpagination({ ...pagination, currentPage: value });
  };

  //Delete Category
  const deleteCategory = async (id) => {
    setloading(true);
    try {
      const res = await dispatch(deleteMainCategory(id));
      if (res) {
        setdeleteConfirm({
          open: false,
          id: null,
        });
        const updatedData = Data.filter((item) => item?._id !== id);
        setData(updatedData);
      } else {
        console.error("Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setloading(false);
    }
  };

  return (
    <>
      {loading ? (
        <TopBarProgress />
      ) : (
        <>
          <div className=" my-5">
            <DashboardPagesLayout
              pageTitle="Main Categories"
              subTitle="items"
              count={pagination?.count}
            >
              <div className="dashboard-pages-table">
                <table>
                  <thead>
                    <tr>
                      <th>Sn#</th>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Image</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Data?.length ? (
                      <>
                        {Data?.map((item, i) => (
                          <tr key={item?._id}>
                            <td
                              className="order-item-number"
                              onClick={() =>
                                navigate(`/admin/view-order/${item?._id}`)
                              }
                            >
                              {i + 1}
                            </td>
                            <td>{item.name}</td>
                            <td>
                              {item.status ? (
                                <span className="text-success">Enable</span>
                              ) : (
                                <span className="text-danger">Disable</span>
                              )}
                            </td>

                            <td>
                              <img
                                src={item.image}
                                height="50px"
                                width="50px"
                                alt="item"
                              />
                            </td>
                            <td>{moment(item?.createdAt).format("l")}</td>
                            <td>
                              <CustomeTableBtn
                                color="secondary"
                                width={"100px"}
                                className={"mr-2"}
                                onClick={() =>
                                  navigate(
                                    `/admin/edit-main-category/?id=${item._id}`
                                  )
                                }
                              >
                                Edit
                              </CustomeTableBtn>

                              <CustomeTableBtn
                                color="danger"
                                width={"100px"}
                                onClick={() =>
                                  setdeleteConfirm({
                                    open: true,
                                    id: item?._id,
                                  })
                                }
                              >
                                Delete
                              </CustomeTableBtn>

                              {deleteConfirm.open && (
                                <DeleteConfirmationDialog
                                  show={true}
                                  message="Are you sure you want to delete?"
                                  onCancel={() =>
                                    setdeleteConfirm({ open: false, id: null })
                                  }
                                  title="Are you sure?"
                                  confirmBtnBsStyle={confirmButtonType.Danger}
                                  onConfirm={(e) => {
                                    deleteCategory(deleteConfirm?.id);
                                  }}
                                  focusCancelBtn={true}
                                />
                              )}
                            </td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        <tr>
                          <td colSpan={9} className=" text-center">
                            {" "}
                            No Record Found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>

                <div className="d-flex justify-content-center align-center p-2">
                  <div className=" mx-auto">
                    <Pagination
                      count={pagination.totalPages}
                      page={pagination.currentPage}
                      onChange={handleChange}
                    />
                  </div>

                  <span
                    className=" font-weight-bold"
                    style={{ color: "#9f9f9f" }}
                  >
                    {Data?.length} of {pagination?.count} Items
                  </span>
                </div>
              </div>
            </DashboardPagesLayout>
          </div>
        </>
      )}
    </>
  );
};

export default MainCategories;
// Trigger recompile
